import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'FeatureItem' })({
    popper: {
        zIndex: 4010
    },
    card: {
        margin: 12,
        display: 'flex',
        flexDirection: 'column',
        width: 416,
        padding: 24,
        alignItems: 'center',
        gap: 24,
        borderRadius: 24,
        background: '#FFF',
        boxShadow: '0px 10px 40px 0px rgba(176, 178, 186, 0.20)',
        boxSizing: 'border-box'
    },
    title: {
        margin: 0,
        color: '#232323',
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '36px',
        letterSpacing: '-0.72px'
    },
    description: {
        color: '#232323',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.32px',
        ['& ul']: {
            margin: 0,
            paddingLeft: 24
        }
    },
    line: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%'
    },
    progress: {
        flex: 1,
        color: '#8E8E8E',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.32px',
        whiteSpace: 'nowrap'
    },
    buttons: {
        flex: 1
    },
    button: {
        height: 40,
        padding: '12px 20px',
        borderRadius: 12,

        fontSize: 14,
        fontWeight: 600,
        lineHeight: '16px'
    },
    back: {
        background: '#F8F8F8 !important',
        color: '#232323'
    },
    next: {
        background: '#232323 !important',
        color: '#FFF'
    },
    elevation: {
        zIndex: '4005 !important'
    }
});
